import { Button } from '@/components/core/Button';

interface DamUploadSummaryEntry {
    label: string;
    count: number;
    linkLabel: string;
    onOpen: () => void;
}

interface DamUploadSummaryProps {
    entries: DamUploadSummaryEntry[];
}

/**
 * Summary strip of the review step (wireframe `7328:237403`): one counter per category with a
 * link to the step and tab where the files can be fixed.
 */
function DamUploadSummary({ entries }: DamUploadSummaryProps) {
    return (
        <ul className="tw-m-0 tw-grid tw-list-none tw-grid-cols-2 tw-gap-px tw-overflow-hidden tw-rounded-lg tw-border tw-border-solid tw-border-primary tw-bg-fill-tertiary tw-p-0 md:tw-grid-cols-5">
            {entries.map((entry) => (
                <li key={entry.label} className="tw-flex tw-items-start tw-justify-between tw-gap-2 tw-bg-fill-primary tw-p-3">
                    <div className="tw-flex tw-min-w-0 tw-flex-col tw-items-start tw-gap-1">
                        <span className="tw-text-t-sm tw-text-t-primary lg:tw-text-t-base">{entry.label}</span>
                        <Button variant="ghost" onClick={entry.onOpen} className="tw-h-auto tw-p-0 tw-font-bold tw-underline">
                            {entry.linkLabel}
                        </Button>
                    </div>
                    <span className="tw-text-t-lg tw-font-bold tw-text-t-primary lg:tw-text-t-xl">{entry.count.toLocaleString()}</span>
                </li>
            ))}
        </ul>
    );
}

export { DamUploadSummary };
export type { DamUploadSummaryEntry, DamUploadSummaryProps };
